import { render } from "./UpdateInfo.vue?vue&type=template&id=664799b2&scoped=true"
import script from "./UpdateInfo.vue?vue&type=script&lang=js"
export * from "./UpdateInfo.vue?vue&type=script&lang=js"

import "./UpdateInfo.vue?vue&type=style&index=0&id=664799b2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-664799b2"

export default script